import { render } from "./VehicleSearch.vue?vue&type=template&id=bfddd3a0&scoped=true"
import script from "./VehicleSearch.vue?vue&type=script&lang=js"
export * from "./VehicleSearch.vue?vue&type=script&lang=js"

import "./VehicleSearch.vue?vue&type=style&index=0&id=bfddd3a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfddd3a0"]])

export default __exports__